var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useState, useEffect, useRef, useMemo, } from "react";
import { useChannel, useTranslation, useFeatureFlags, useExternalUsers, } from "../../hooks";
import S from "./MessageInput.styled";
import EmojiButton from "./EmojiButton";
import SendIcon from "../../assets/icons/SendIcon";
import ReplyMessage from "../Message/ReplyMessage";
import UploadIcon from "../../assets/icons/UploadIcon";
import FileUpload from "../FileUpload/FileUpload";
import Spinner from "../Ui/Spinner/Spinner";
const MessageInput = () => {
    var _a, _b;
    const flags = useFeatureFlags();
    const channel = useChannel();
    const strings = useTranslation();
    const users = useExternalUsers();
    const [value, setValue] = useState("");
    const [replyMessage, setReplyMessage] = useState(null);
    const textAreaElement = useRef(null);
    const uploadRef = useRef(null);
    const [file, setFile] = useState(null);
    const [sending, setSending] = useState(false);
    useEffect(() => {
        channel.setReplyMessage(null);
    }, [channel]);
    useEffect(() => {
        const unsubscribeFunctions = [
            channel.on("replyMessage", (event) => {
                const { message } = event;
                setReplyMessage(message);
            }),
        ];
        return () => {
            unsubscribeFunctions.forEach((f) => f.unsubscribe());
        };
    }, [channel]);
    useEffect(() => {
        var _a;
        (_a = textAreaElement === null || textAreaElement === void 0 ? void 0 : textAreaElement.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [textAreaElement, value, replyMessage, file]);
    useEffect(() => {
        var _a;
        (_a = textAreaElement === null || textAreaElement === void 0 ? void 0 : textAreaElement.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [channel]);
    const handleSend = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d;
        if (sending)
            return;
        setSending(true);
        let token = "";
        let auth = "";
        if (typeof window !== "undefined") {
            auth = (_c = sessionStorage.getItem("current-user-token")) !== null && _c !== void 0 ? _c : "";
        }
        if (file) {
            const data = new FormData();
            data.append("file", file);
            const resp = yield fetch(`${flags.storageUrl}/upload`, {
                method: "POST",
                body: data,
                headers: {
                    authorization: auth,
                },
            });
            const responseData = yield resp.json();
            token = (_d = responseData === null || responseData === void 0 ? void 0 : responseData.token) !== null && _d !== void 0 ? _d : "";
        }
        if (value.trim().length > 0 || token) {
            channel.sendMessage(value, token);
            setValue("");
        }
        setFile(null);
        setSending(false);
    }), [channel, file, flags, value, sending]);
    const handleKeyPress = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        if (e.key !== "Enter" || e.shiftKey) {
            return;
        }
        e.preventDefault();
        yield handleSend();
    }), [handleSend]);
    const handleChange = useCallback(({ target }) => {
        setValue(target.value);
    }, [setValue]);
    const channelName = (_b = (_a = channel.data) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
    const privateMessName = useMemo(() => {
        var _a;
        if (channel.data.members) {
            const nameId = channel.data.members.filter((m) => m !== channel.currentUserId)[0];
            const u = users.get(nameId);
            return (_a = u === null || u === void 0 ? void 0 : u.name) !== null && _a !== void 0 ? _a : channel.data.name;
        }
    }, [users, channel.data.members]);
    const name = channel.channelType === "private" ? privateMessName : channelName;
    const isReadOnly = name === undefined;
    const placeholder = name ? strings.messageInputPlaceholder + name : "";
    return (React.createElement(React.Fragment, null,
        React.createElement(ReplyMessage, { hasCloseBtn: true, message: replyMessage }),
        React.createElement(S.Wrapper, { isVisible: value.length > 0, hasFile: !!flags.storageUrl },
            sending && React.createElement(Spinner, null),
            React.createElement(S.Textarea, { "data-testid": "messageInput", readOnly: isReadOnly, minRows: 1, maxRows: 10, maxLength: 2048, autoFocus: true, disabled: sending, "aria-label": placeholder, placeholder: placeholder, onKeyPress: handleKeyPress, value: value, onChange: handleChange, ref: textAreaElement, onFocus: () => channel.markLastMessageAsRead(), onClick: () => channel.markLastMessageAsRead() }),
            React.createElement(EmojiButton, { value: value, setValue: setValue }),
            flags.storageUrl ? (React.createElement(S.Btn, { onClick: () => { var _a; return (_a = uploadRef.current) === null || _a === void 0 ? void 0 : _a.click(); } },
                React.createElement(UploadIcon, null),
                React.createElement("input", { style: { display: "none" }, type: "file", name: "upload_file", ref: uploadRef, onChange: (e) => {
                        var _a;
                        const f = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                        if (!f)
                            return;
                        setFile(f);
                    } }))) : null,
            React.createElement(S.SendIconWrapper, { onClick: handleSend, "aria-label": "Send message", disabled: !(value.length > 0 || !!file) },
                React.createElement(SendIcon, null)),
            file ? (React.createElement(FileUpload, { file: file, handleClose: sending ? undefined : () => setFile(null) })) : null)));
};
export default MessageInput;
//# sourceMappingURL=MessageInput.js.map